export default __webpack_public_path__ + "static/media/phoneIcon.3cac1b57.svg";